import { generateApiUrl } from "@/shared/utils";
/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const getOneEvidence = async (evidenceId) => {
  try {
    const url = generateApiUrl(["kanoon", "evidence_id"], [evidenceId]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const evidence = pathOr("", ["evidence"], data);
    const captionThirdPerson = pathOr("", ["caption_third_person"], data);
    const captionImperative = pathOr("", ["caption_imperative"], data);
    const exercise = pathOr(null, ["exercise"], data);
    const indicator = pathOr(null, ["indicator"], data);
    const status = pathOr(null, ["status"], data);

    return {
      exercise,
      indicator,
      evidence,
      captionThirdPerson,
      captionImperative,
      status,
    };
  } catch (error) {
    throw error;
  }
};
export const addEvidence = async (
  exerciseId,
  indicatorId,
  secondPersonEvidence,
  captionThirdPerson,
  captionImperative,
  status
) => {
  try {
    const url = generateApiUrl(["kanoon", "evidence"]);
    const payload = {
      exercise_id: exerciseId,
      indicator_id: indicatorId,
      evidence: secondPersonEvidence,
      caption_third_person: captionThirdPerson,
      caption_imperative: captionImperative,
      status,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const editEvidence = async (
  id,
  exerciseId,
  indicatorId,
  secondPersonEvidence,
  captionThirdPerson,
  captionImperative,
  status
) => {
  try {
    const url = generateApiUrl(["kanoon", "v2", "evidence_id"], [id]);
    const payload = {
      exercise_id: exerciseId,
      indicator_id: indicatorId,
      evidence: secondPersonEvidence,
      caption_third_person: captionThirdPerson,
      caption_imperative: captionImperative,
      status,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const cloneEvidence = async (evidenceId, exerciseId, indicatorId) => {
  try {
    const url = generateApiUrl(["kanoon", "evidence_id"], [evidenceId]);
    const payload = {
      exercise_id: exerciseId,
      indicator_id: indicatorId,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const deleteEvidence = async (evidenceId) => {
  try {
    const url = generateApiUrl(["kanoon", "evidence_id"], [evidenceId]);
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const referenceEvidence = async (evidenceId, referenceEvidenceId) => {
  try {
    const url = generateApiUrl(["kanoon", "evidence_reference"], [evidenceId]);
    const payload = { reference_id: referenceEvidenceId };
    const response = await httpService.patch(url, payload);
    const evidence = pathOr(null, ["data", "data"], response);
    const message = pathOr(null, ["data", "message"], response);
    return { evidence, message };
  } catch (error) {
    throw error;
  }
};
export const getAllSamples = async (
  exerciseId,
  indicatorId,
  evidenceId,
  page = 1,
  getPerPage = 10
) => {
  try {
    const queryString = { page, per_page: getPerPage };
    const url = generateApiUrl(
      ["kanoon", "exercise_indicator_evidence_sample"],
      [exerciseId, indicatorId, evidenceId],
      queryString
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const total = pathOr(0, ["total"], data);
    const count = pathOr(0, ["count"], data);
    const totalPages = pathOr(0, ["total_pages"], data);
    const currentPage = pathOr(1, ["current_page"], data);
    const perPage = pathOr(10, ["per_page"], data);
    const items = pathOr([], ["result"], data);

    return { total, count, totalPages, currentPage, perPage, items };
  } catch (error) {
    throw error;
  }
};
